module.exports = __webpack_public_path__ + "static/media/blog-37-img3.81d25304.webp";